import { HELP_LINK } from '@percent/cause-dashboard/constants/support'
import { Alert, Spacer, Typography } from '@percent/lemonade'

import styles from './BankDetailsReview.module.scss'
import { BankDetailsReviewProps } from './BankDetailsReview.types'

export function BankDetailsReview({
  reviewBadgeText = '',
  reviewText = '',
  reviewLinkText,
  variant
}: BankDetailsReviewProps) {
  return (
    <>
      {' '}
      <div className={styles.bankDetailsBadge}>
        <Alert variant={variant}>{reviewBadgeText}</Alert>
      </div>
      {reviewText && (
        <>
          <Spacer size={4} axis="vertical" />
          <Typography variant="default" className={styles.reviewText} $color="gray600">
            {reviewText}{' '}
            <a href={HELP_LINK} target="_blank" rel="noreferrer" className={styles.formLink}>
              {reviewLinkText}
            </a>
            .
          </Typography>
          <Spacer size={4} axis="vertical" />
        </>
      )}
    </>
  )
}
